var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { markRaw, shallowReactive, resolveComponent, resolveDirective, withDirectives, openBlock, createElementBlock, normalizeClass, renderSlot, createCommentVNode, createBlock, resolveDynamicComponent, normalizeStyle, withCtx, Fragment, renderList, mergeProps, toHandlers, createVNode, normalizeProps, guardReactiveProps, h, reactive } from 'vue';
import { ResizeObserver as ResizeObserver$1 } from 'vue-resize';
import { ObserveVisibility } from 'vue-observe-visibility';
import mitt from 'mitt';
var config = {
    itemsLimit: 1000
};
// Fork of https://github.com/olahol/scrollparent.js to be able to build with Rollup
var regex = /(auto|scroll)/;
function parents(node, ps) {
    if (node.parentNode === null) {
        return ps;
    }
    return parents(node.parentNode, ps.concat([node]));
}
var style = function style(node, prop) {
    return getComputedStyle(node, null).getPropertyValue(prop);
};
var overflow = function overflow(node) {
    return style(node, 'overflow') + style(node, 'overflow-y') + style(node, 'overflow-x');
};
var scroll = function scroll(node) {
    return regex.test(overflow(node));
};
function getScrollParent(node) {
    if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
        return;
    }
    var ps = parents(node.parentNode, []);
    for (var i = 0; i < ps.length; i += 1) {
        if (scroll(ps[i])) {
            return ps[i];
        }
    }
    return document.scrollingElement || document.documentElement;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var props = {
    items: {
        type: Array,
        required: true
    },
    keyField: {
        type: String,
        default: 'id'
    },
    direction: {
        type: String,
        default: 'vertical',
        validator: function validator(value) {
            return ['vertical', 'horizontal'].includes(value);
        }
    },
    listTag: {
        type: String,
        default: 'div'
    },
    itemTag: {
        type: String,
        default: 'div'
    }
};
function simpleArray() {
    return this.items.length && _typeof(this.items[0]) !== 'object';
}
var supportsPassive = false;
if (typeof window !== 'undefined') {
    supportsPassive = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function get() {
                supportsPassive = true;
            }
        });
        window.addEventListener('test', null, opts);
    }
    catch (e) { }
}
var uid = 0;
var script$2 = {
    name: 'RecycleScroller',
    components: {
        ResizeObserver: ResizeObserver$1,
    },
    directives: {
        ObserveVisibility: ObserveVisibility,
    },
    props: __assign(__assign({}, props), { itemSize: {
            type: Number,
            default: null,
        }, gridItems: {
            type: Number,
            default: undefined,
        }, itemSecondarySize: {
            type: Number,
            default: undefined,
        }, minItemSize: {
            type: [Number, String],
            default: null,
        }, sizeField: {
            type: String,
            default: 'size',
        }, typeField: {
            type: String,
            default: 'type',
        }, buffer: {
            type: Number,
            default: 200,
        }, pageMode: {
            type: Boolean,
            default: false,
        }, prerender: {
            type: Number,
            default: 0,
        }, emitUpdate: {
            type: Boolean,
            default: false,
        }, updateInterval: {
            type: Number,
            default: 0,
        }, skipHover: {
            type: Boolean,
            default: false,
        }, listTag: {
            type: String,
            default: 'div',
        }, itemTag: {
            type: String,
            default: 'div',
        }, listClass: {
            type: [String, Object, Array],
            default: '',
        }, itemClass: {
            type: [String, Object, Array],
            default: '',
        } }),
    emits: [
        'resize',
        'visible',
        'hidden',
        'update',
        'scroll-start',
        'scroll-end',
    ],
    data: function () {
        return {
            pool: [],
            totalSize: 0,
            ready: false,
            hoverKey: null,
        };
    },
    computed: {
        sizes: function () {
            if (this.itemSize === null) {
                var sizes = {
                    '-1': { accumulator: 0 },
                };
                var items = this.items;
                var field = this.sizeField;
                var minItemSize = this.minItemSize;
                var computedMinSize = 10000;
                var accumulator = 0;
                var current = void 0;
                for (var i = 0, l = items.length; i < l; i++) {
                    current = items[i][field] || minItemSize;
                    if (current < computedMinSize) {
                        computedMinSize = current;
                    }
                    accumulator += current;
                    sizes[i] = { accumulator: accumulator, size: current };
                }
                // eslint-disable-next-line
                this.$_computedMinItemSize = computedMinSize;
                return sizes;
            }
            return [];
        },
        simpleArray: simpleArray,
        itemIndexByKey: function () {
            var _a = this, keyField = _a.keyField, items = _a.items;
            var result = {};
            for (var i = 0, l = items.length; i < l; i++) {
                result[items[i][keyField]] = i;
            }
            return result;
        },
    },
    watch: {
        items: function () {
            this.updateVisibleItems(true);
        },
        pageMode: function () {
            this.applyPageMode();
            this.updateVisibleItems(false);
        },
        sizes: {
            handler: function () {
                this.updateVisibleItems(false);
            },
            deep: true,
        },
        gridItems: function () {
            this.updateVisibleItems(true);
        },
        itemSecondarySize: function () {
            this.updateVisibleItems(true);
        },
    },
    created: function () {
        this.$_startIndex = 0;
        this.$_endIndex = 0;
        this.$_views = new Map();
        this.$_unusedViews = new Map();
        this.$_scrollDirty = false;
        this.$_lastUpdateScrollPosition = 0;
        // In SSR mode, we also prerender the same number of item for the first render
        // to avoir mismatch between server and client templates
        if (this.prerender) {
            this.$_prerender = true;
            this.updateVisibleItems(false);
        }
        if (this.gridItems && !this.itemSize) {
            console.error('[vue-recycle-scroller] You must provide an itemSize when using gridItems');
        }
    },
    mounted: function () {
        var _this_1 = this;
        this.applyPageMode();
        this.$nextTick(function () {
            // In SSR mode, render the real number of visible items
            _this_1.$_prerender = false;
            _this_1.updateVisibleItems(true);
            _this_1.ready = true;
        });
    },
    activated: function () {
        var _this_1 = this;
        var lastPosition = this.$_lastUpdateScrollPosition;
        if (typeof lastPosition === 'number') {
            this.$nextTick(function () {
                _this_1.scrollToPosition(lastPosition);
            });
        }
    },
    beforeUnmount: function () {
        this.removeListeners();
    },
    methods: {
        addView: function (pool, index, item, key, type) {
            var nr = markRaw({
                id: uid++,
                index: index,
                used: true,
                key: key,
                type: type,
            });
            var view = shallowReactive({
                item: item,
                position: 0,
                nr: nr,
            });
            pool.push(view);
            return view;
        },
        unuseView: function (view, fake) {
            if (fake === void 0) { fake = false; }
            var unusedViews = this.$_unusedViews;
            var type = view.nr.type;
            var unusedPool = unusedViews.get(type);
            if (!unusedPool) {
                unusedPool = [];
                unusedViews.set(type, unusedPool);
            }
            unusedPool.push(view);
            if (!fake) {
                view.nr.used = false;
                view.position = -9999;
            }
        },
        handleResize: function () {
            this.$emit('resize');
            if (this.ready)
                this.updateVisibleItems(false);
        },
        handleScroll: function (event) {
            var _this_1 = this;
            if (!this.$_scrollDirty) {
                this.$_scrollDirty = true;
                if (this.$_updateTimeout)
                    return;
                var requestUpdate_1 = function () { return requestAnimationFrame(function () {
                    _this_1.$_scrollDirty = false;
                    var continuous = _this_1.updateVisibleItems(false, true).continuous;
                    // It seems sometimes chrome doesn't fire scroll event :/
                    // When non continous scrolling is ending, we force a refresh
                    if (!continuous) {
                        clearTimeout(_this_1.$_refreshTimout);
                        _this_1.$_refreshTimout = setTimeout(_this_1.handleScroll, _this_1.updateInterval + 100);
                    }
                }); };
                requestUpdate_1();
                // Schedule the next update with throttling
                if (this.updateInterval) {
                    this.$_updateTimeout = setTimeout(function () {
                        _this_1.$_updateTimeout = 0;
                        if (_this_1.$_scrollDirty)
                            requestUpdate_1();
                    }, this.updateInterval);
                }
            }
        },
        handleVisibilityChange: function (isVisible, entry) {
            var _this_1 = this;
            if (this.ready) {
                if (isVisible || entry.boundingClientRect.width !== 0 || entry.boundingClientRect.height !== 0) {
                    this.$emit('visible');
                    requestAnimationFrame(function () {
                        _this_1.updateVisibleItems(false);
                    });
                }
                else {
                    this.$emit('hidden');
                }
            }
        },
        updateVisibleItems: function (checkItem, checkPositionDiff) {
            if (checkPositionDiff === void 0) { checkPositionDiff = false; }
            var itemSize = this.itemSize;
            var gridItems = this.gridItems || 1;
            var itemSecondarySize = this.itemSecondarySize || itemSize;
            var minItemSize = this.$_computedMinItemSize;
            var typeField = this.typeField;
            var keyField = this.simpleArray ? null : this.keyField;
            var items = this.items;
            var count = items.length;
            var sizes = this.sizes;
            var views = this.$_views;
            var unusedViews = this.$_unusedViews;
            var pool = this.pool;
            var itemIndexByKey = this.itemIndexByKey;
            var startIndex, endIndex;
            var totalSize;
            var visibleStartIndex, visibleEndIndex;
            if (!count) {
                startIndex = endIndex = visibleStartIndex = visibleEndIndex = totalSize = 0;
            }
            else if (this.$_prerender) {
                startIndex = visibleStartIndex = 0;
                endIndex = visibleEndIndex = Math.min(this.prerender, items.length);
                totalSize = null;
            }
            else {
                var scroll_1 = this.getScroll();
                // Skip update if use hasn't scrolled enough
                if (checkPositionDiff) {
                    var positionDiff = scroll_1.start - this.$_lastUpdateScrollPosition;
                    if (positionDiff < 0)
                        positionDiff = -positionDiff;
                    if ((itemSize === null && positionDiff < minItemSize) || positionDiff < itemSize) {
                        return {
                            continuous: true,
                        };
                    }
                }
                this.$_lastUpdateScrollPosition = scroll_1.start;
                var buffer = this.buffer;
                scroll_1.start -= buffer;
                scroll_1.end += buffer;
                // account for leading slot
                var beforeSize = 0;
                if (this.$refs.before) {
                    beforeSize = this.$refs.before.scrollHeight;
                    scroll_1.start -= beforeSize;
                }
                // account for trailing slot
                if (this.$refs.after) {
                    var afterSize = this.$refs.after.scrollHeight;
                    scroll_1.end += afterSize;
                }
                // Variable size mode
                if (itemSize === null) {
                    var h_1;
                    var a = 0;
                    var b = count - 1;
                    var i = ~~(count / 2);
                    var oldI = void 0;
                    // Searching for startIndex
                    do {
                        oldI = i;
                        h_1 = sizes[i].accumulator;
                        if (h_1 < scroll_1.start) {
                            a = i;
                        }
                        else if (i < count - 1 && sizes[i + 1].accumulator > scroll_1.start) {
                            b = i;
                        }
                        i = ~~((a + b) / 2);
                    } while (i !== oldI);
                    i < 0 && (i = 0);
                    startIndex = i;
                    // For container style
                    totalSize = sizes[count - 1].accumulator;
                    // Searching for endIndex
                    for (endIndex = i; endIndex < count && sizes[endIndex].accumulator < scroll_1.end; endIndex++)
                        ;
                    if (endIndex === -1) {
                        endIndex = items.length - 1;
                    }
                    else {
                        endIndex++;
                        // Bounds
                        endIndex > count && (endIndex = count);
                    }
                    // search visible startIndex
                    for (visibleStartIndex = startIndex; visibleStartIndex < count && (beforeSize + sizes[visibleStartIndex].accumulator) < scroll_1.start; visibleStartIndex++)
                        ;
                    // search visible endIndex
                    for (visibleEndIndex = visibleStartIndex; visibleEndIndex < count && (beforeSize + sizes[visibleEndIndex].accumulator) < scroll_1.end; visibleEndIndex++)
                        ;
                }
                else {
                    // Fixed size mode
                    startIndex = ~~(scroll_1.start / itemSize * gridItems);
                    var remainer = startIndex % gridItems;
                    startIndex -= remainer;
                    endIndex = Math.ceil(scroll_1.end / itemSize * gridItems);
                    visibleStartIndex = Math.max(0, Math.floor((scroll_1.start - beforeSize) / itemSize * gridItems));
                    visibleEndIndex = Math.floor((scroll_1.end - beforeSize) / itemSize * gridItems);
                    // Bounds
                    startIndex < 0 && (startIndex = 0);
                    endIndex > count && (endIndex = count);
                    visibleStartIndex < 0 && (visibleStartIndex = 0);
                    visibleEndIndex > count && (visibleEndIndex = count);
                    totalSize = Math.ceil(count / gridItems) * itemSize;
                }
            }
            if (endIndex - startIndex > config.itemsLimit) {
                this.itemsLimitError();
            }
            this.totalSize = totalSize;
            var view;
            var continuous = startIndex <= this.$_endIndex && endIndex >= this.$_startIndex;
            // Unuse views that are no longer visible
            if (continuous) {
                for (var i = 0, l = pool.length; i < l; i++) {
                    view = pool[i];
                    if (view.nr.used) {
                        // Update view item index
                        if (checkItem) {
                            view.nr.index = itemIndexByKey[view.item[keyField]];
                        }
                        // Check if index is still in visible range
                        if (view.nr.index == null ||
                            view.nr.index < startIndex ||
                            view.nr.index >= endIndex) {
                            this.unuseView(view);
                        }
                    }
                }
            }
            var unusedIndex = continuous ? null : new Map();
            var item, type;
            var v;
            for (var i = startIndex; i < endIndex; i++) {
                item = items[i];
                var key = keyField ? item[keyField] : item;
                if (key == null) {
                    throw new Error("Key is ".concat(key, " on item (keyField is '").concat(keyField, "')"));
                }
                view = views.get(key);
                if (!itemSize && !sizes[i].size) {
                    if (view)
                        this.unuseView(view);
                    continue;
                }
                type = item[typeField];
                var unusedPool = unusedViews.get(type);
                var newlyUsedView = false;
                // No view assigned to item
                if (!view) {
                    if (continuous) {
                        // Reuse existing view
                        if (unusedPool && unusedPool.length) {
                            view = unusedPool.pop();
                        }
                        else {
                            view = this.addView(pool, i, item, key, type);
                        }
                    }
                    else {
                        // Use existing view
                        // We don't care if they are already used
                        // because we are not in continous scrolling
                        v = unusedIndex.get(type) || 0;
                        if (!unusedPool || v >= unusedPool.length) {
                            view = this.addView(pool, i, item, key, type);
                            this.unuseView(view, true);
                            unusedPool = unusedViews.get(type);
                        }
                        view = unusedPool[v];
                        unusedIndex.set(type, v + 1);
                    }
                    // Assign view to item
                    views.delete(view.nr.key);
                    view.nr.used = true;
                    view.nr.index = i;
                    view.nr.key = key;
                    view.nr.type = type;
                    views.set(key, view);
                    newlyUsedView = true;
                }
                else {
                    // View already assigned to item
                    if (!view.nr.used) {
                        view.nr.used = true;
                        newlyUsedView = true;
                        if (unusedPool) {
                            var index = unusedPool.indexOf(view);
                            if (index !== -1)
                                unusedPool.splice(index, 1);
                        }
                    }
                }
                // Always set item in case it's a new object with the same key
                view.item = item;
                if (newlyUsedView) {
                    if (i === items.length - 1)
                        this.$emit('scroll-end');
                    if (i === 0)
                        this.$emit('scroll-start');
                }
                // Update position
                if (itemSize === null) {
                    view.position = sizes[i - 1].accumulator;
                    view.offset = 0;
                }
                else {
                    view.position = Math.floor(i / gridItems) * itemSize;
                    view.offset = (i % gridItems) * itemSecondarySize;
                }
            }
            this.$_startIndex = startIndex;
            this.$_endIndex = endIndex;
            if (this.emitUpdate)
                this.$emit('update', startIndex, endIndex, visibleStartIndex, visibleEndIndex);
            // After the user has finished scrolling
            // Sort views so text selection is correct
            clearTimeout(this.$_sortTimer);
            this.$_sortTimer = setTimeout(this.sortViews, this.updateInterval + 300);
            return {
                continuous: continuous,
            };
        },
        getListenerTarget: function () {
            var target = getScrollParent(this.$el);
            // Fix global scroll target for Chrome and Safari
            if (window.document && (target === window.document.documentElement || target === window.document.body)) {
                target = window;
            }
            return target;
        },
        getScroll: function () {
            var _a = this, el = _a.$el, direction = _a.direction;
            var isVertical = direction === 'vertical';
            var scrollState;
            if (this.pageMode) {
                var bounds = el.getBoundingClientRect();
                var boundsSize = isVertical ? bounds.height : bounds.width;
                var start = -(isVertical ? bounds.top : bounds.left);
                var size = isVertical ? window.innerHeight : window.innerWidth;
                if (start < 0) {
                    size += start;
                    start = 0;
                }
                if (start + size > boundsSize) {
                    size = boundsSize - start;
                }
                scrollState = {
                    start: start,
                    end: start + size,
                };
            }
            else if (isVertical) {
                scrollState = {
                    start: el.scrollTop,
                    end: el.scrollTop + el.clientHeight,
                };
            }
            else {
                scrollState = {
                    start: el.scrollLeft,
                    end: el.scrollLeft + el.clientWidth,
                };
            }
            return scrollState;
        },
        applyPageMode: function () {
            if (this.pageMode) {
                this.addListeners();
            }
            else {
                this.removeListeners();
            }
        },
        addListeners: function () {
            this.listenerTarget = this.getListenerTarget();
            this.listenerTarget.addEventListener('scroll', this.handleScroll, supportsPassive
                ? {
                    passive: true,
                }
                : false);
            this.listenerTarget.addEventListener('resize', this.handleResize);
        },
        removeListeners: function () {
            if (!this.listenerTarget) {
                return;
            }
            this.listenerTarget.removeEventListener('scroll', this.handleScroll);
            this.listenerTarget.removeEventListener('resize', this.handleResize);
            this.listenerTarget = null;
        },
        scrollToItem: function (index) {
            var scroll;
            var gridItems = this.gridItems || 1;
            if (this.itemSize === null) {
                scroll = index > 0 ? this.sizes[index - 1].accumulator : 0;
            }
            else {
                scroll = Math.floor(index / gridItems) * this.itemSize;
            }
            this.scrollToPosition(scroll);
        },
        scrollToPosition: function (position) {
            var direction = this.direction === 'vertical'
                ? { scroll: 'scrollTop', start: 'top' }
                : { scroll: 'scrollLeft', start: 'left' };
            var viewport;
            var scrollDirection;
            var scrollDistance;
            if (this.pageMode) {
                var viewportEl = getScrollParent(this.$el);
                // HTML doesn't overflow like other elements
                var scrollTop = viewportEl.tagName === 'HTML' ? 0 : viewportEl[direction.scroll];
                var bounds = viewportEl.getBoundingClientRect();
                var scroller = this.$el.getBoundingClientRect();
                var scrollerPosition = scroller[direction.start] - bounds[direction.start];
                viewport = viewportEl;
                scrollDirection = direction.scroll;
                scrollDistance = position + scrollTop + scrollerPosition;
            }
            else {
                viewport = this.$el;
                scrollDirection = direction.scroll;
                scrollDistance = position;
            }
            viewport[scrollDirection] = scrollDistance;
        },
        itemsLimitError: function () {
            var _this_1 = this;
            setTimeout(function () {
                console.log('It seems the scroller element isn\'t scrolling, so it tries to render all the items at once.', 'Scroller:', _this_1.$el);
                console.log('Make sure the scroller has a fixed height (or width) and \'overflow-y\' (or \'overflow-x\') set to \'auto\' so it can scroll correctly and only render the items visible in the scroll viewport.');
            });
            throw new Error('Rendered items limit reached');
        },
        sortViews: function () {
            this.pool.sort(function (viewA, viewB) { return viewA.nr.index - viewB.nr.index; });
        },
    },
};
var _hoisted_1 = {
    key: 0,
    ref: "before",
    class: "vue-recycle-scroller__slot"
};
var _hoisted_2 = {
    key: 1,
    ref: "after",
    class: "vue-recycle-scroller__slot"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    var _component_ResizeObserver = resolveComponent("ResizeObserver");
    var _directive_observe_visibility = resolveDirective("observe-visibility");
    return withDirectives((openBlock(), createElementBlock("div", {
        class: normalizeClass(["vue-recycle-scroller", (_a = {
                    ready: $data.ready,
                    'page-mode': $props.pageMode
                },
                _a["direction-".concat(_ctx.direction)] = true,
                _a)]),
        onScrollPassive: _cache[0] || (_cache[0] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return ($options.handleScroll && $options.handleScroll.apply($options, __spreadArray([], __read(args), false)));
        })
    }, [
        (_ctx.$slots.before)
            ? (openBlock(), createElementBlock("div", _hoisted_1, [
                renderSlot(_ctx.$slots, "before")
            ], 512 /* NEED_PATCH */))
            : createCommentVNode("v-if", true),
        (openBlock(), createBlock(resolveDynamicComponent($props.listTag), {
            ref: "wrapper",
            style: normalizeStyle((_b = {}, _b[_ctx.direction === 'vertical' ? 'minHeight' : 'minWidth'] = $data.totalSize + 'px', _b)),
            class: normalizeClass(["vue-recycle-scroller__item-wrapper", $props.listClass])
        }, {
            default: withCtx(function () { return [
                (openBlock(true), createElementBlock(Fragment, null, renderList($data.pool, function (view) {
                    return (openBlock(), createBlock(resolveDynamicComponent($props.itemTag), mergeProps({
                        key: view.nr.id,
                        style: $data.ready ? {
                            transform: "translate".concat(_ctx.direction === 'vertical' ? 'Y' : 'X', "(").concat(view.position, "px) translate").concat(_ctx.direction === 'vertical' ? 'X' : 'Y', "(").concat(view.offset, "px)"),
                            width: $props.gridItems ? "".concat(_ctx.direction === 'vertical' ? $props.itemSecondarySize || $props.itemSize : $props.itemSize, "px") : undefined,
                            height: $props.gridItems ? "".concat(_ctx.direction === 'horizontal' ? $props.itemSecondarySize || $props.itemSize : $props.itemSize, "px") : undefined,
                        } : null,
                        class: ["vue-recycle-scroller__item-view", [
                                $props.itemClass,
                                {
                                    hover: !$props.skipHover && $data.hoverKey === view.nr.key
                                },
                            ]]
                    }, toHandlers($props.skipHover ? {} : {
                        mouseenter: function () { $data.hoverKey = view.nr.key; },
                        mouseleave: function () { $data.hoverKey = null; },
                    })), {
                        default: withCtx(function () { return [
                            renderSlot(_ctx.$slots, "default", {
                                item: view.item,
                                index: view.nr.index,
                                active: view.nr.used
                            })
                        ]; }),
                        _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["style", "class"]));
                }), 128 /* KEYED_FRAGMENT */)),
                renderSlot(_ctx.$slots, "empty")
            ]; }),
            _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["style", "class"])),
        (_ctx.$slots.after)
            ? (openBlock(), createElementBlock("div", _hoisted_2, [
                renderSlot(_ctx.$slots, "after")
            ], 512 /* NEED_PATCH */))
            : createCommentVNode("v-if", true),
        createVNode(_component_ResizeObserver, { onNotify: $options.handleResize }, null, 8 /* PROPS */, ["onNotify"])
    ], 34 /* CLASS, HYDRATE_EVENTS */)), [
        [_directive_observe_visibility, $options.handleVisibilityChange]
    ]);
}
script$2.render = render$1;
script$2.__file = "src/components/RecycleScroller.vue";
var script$1 = {
    name: 'DynamicScroller',
    components: {
        RecycleScroller: script$2,
    },
    provide: function () {
        if (typeof ResizeObserver !== 'undefined') {
            this.$_resizeObserver = new ResizeObserver(function (entries) {
                requestAnimationFrame(function () {
                    var e_1, _a;
                    if (!Array.isArray(entries)) {
                        return;
                    }
                    try {
                        for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                            var entry = entries_1_1.value;
                            if (entry.target && entry.target.$_vs_onResize) {
                                var width = void 0, height = void 0;
                                if (entry.borderBoxSize) {
                                    var resizeObserverSize = entry.borderBoxSize[0];
                                    width = resizeObserverSize.inlineSize;
                                    height = resizeObserverSize.blockSize;
                                }
                                else {
                                    // @TODO remove when contentRect is deprecated
                                    width = entry.contentRect.width;
                                    height = entry.contentRect.height;
                                }
                                entry.target.$_vs_onResize(entry.target.$_vs_id, width, height);
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                });
            });
        }
        return {
            vscrollData: this.vscrollData,
            vscrollParent: this,
            vscrollResizeObserver: this.$_resizeObserver,
        };
    },
    inheritAttrs: false,
    props: __assign(__assign({}, props), { minItemSize: {
            type: [Number, String],
            required: true,
        } }),
    emits: [
        'resize',
        'visible',
    ],
    data: function () {
        return {
            vscrollData: {
                active: true,
                sizes: {},
                keyField: this.keyField,
                simpleArray: false,
            },
        };
    },
    computed: {
        simpleArray: simpleArray,
        itemsWithSize: function () {
            var result = [];
            var _a = this, items = _a.items, keyField = _a.keyField, simpleArray = _a.simpleArray;
            var sizes = this.vscrollData.sizes;
            var l = items.length;
            for (var i = 0; i < l; i++) {
                var item = items[i];
                var id = simpleArray ? i : item[keyField];
                var size = sizes[id];
                if (typeof size === 'undefined' && !this.$_undefinedMap[id]) {
                    size = 0;
                }
                result.push({
                    item: item,
                    id: id,
                    size: size,
                });
            }
            return result;
        },
    },
    watch: {
        items: function () {
            this.forceUpdate();
        },
        simpleArray: {
            handler: function (value) {
                this.vscrollData.simpleArray = value;
            },
            immediate: true,
        },
        direction: function (value) {
            this.forceUpdate(true);
        },
        itemsWithSize: function (next, prev) {
            var scrollTop = this.$el.scrollTop;
            // Calculate total diff between prev and next sizes
            // over current scroll top. Then add it to scrollTop to
            // avoid jumping the contents that the user is seeing.
            var prevActiveTop = 0;
            var activeTop = 0;
            var length = Math.min(next.length, prev.length);
            for (var i = 0; i < length; i++) {
                if (prevActiveTop >= scrollTop) {
                    break;
                }
                prevActiveTop += prev[i].size || this.minItemSize;
                activeTop += next[i].size || this.minItemSize;
            }
            var offset = activeTop - prevActiveTop;
            if (offset === 0) {
                return;
            }
            this.$el.scrollTop += offset;
        },
    },
    beforeCreate: function () {
        this.$_updates = [];
        this.$_undefinedSizes = 0;
        this.$_undefinedMap = {};
        this.$_events = mitt();
    },
    activated: function () {
        this.vscrollData.active = true;
    },
    deactivated: function () {
        this.vscrollData.active = false;
    },
    unmounted: function () {
        this.$_events.all.clear();
    },
    methods: {
        onScrollerResize: function () {
            var scroller = this.$refs.scroller;
            if (scroller) {
                this.forceUpdate();
            }
            this.$emit('resize');
        },
        onScrollerVisible: function () {
            this.$_events.emit('vscroll:update', { force: false });
            this.$emit('visible');
        },
        forceUpdate: function (clear) {
            if (clear === void 0) { clear = false; }
            if (clear || this.simpleArray) {
                this.vscrollData.sizes = {};
            }
            this.$_events.emit('vscroll:update', { force: true });
        },
        scrollToItem: function (index) {
            var scroller = this.$refs.scroller;
            if (scroller)
                scroller.scrollToItem(index);
        },
        getItemSize: function (item, index) {
            if (index === void 0) { index = undefined; }
            var id = this.simpleArray ? (index != null ? index : this.items.indexOf(item)) : item[this.keyField];
            return this.vscrollData.sizes[id] || 0;
        },
        scrollToBottom: function () {
            var _this_1 = this;
            if (this.$_scrollingToBottom)
                return;
            this.$_scrollingToBottom = true;
            var el = this.$el;
            // Item is inserted to the DOM
            this.$nextTick(function () {
                el.scrollTop = el.scrollHeight + 5000;
                // Item sizes are computed
                var cb = function () {
                    el.scrollTop = el.scrollHeight + 5000;
                    requestAnimationFrame(function () {
                        el.scrollTop = el.scrollHeight + 5000;
                        if (_this_1.$_undefinedSizes === 0) {
                            _this_1.$_scrollingToBottom = false;
                        }
                        else {
                            requestAnimationFrame(cb);
                        }
                    });
                };
                requestAnimationFrame(cb);
            });
        },
    },
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_RecycleScroller = resolveComponent("RecycleScroller");
    return (openBlock(), createBlock(_component_RecycleScroller, mergeProps({
        ref: "scroller",
        items: $options.itemsWithSize,
        "min-item-size": $props.minItemSize,
        direction: _ctx.direction,
        "key-field": "id",
        "list-tag": _ctx.listTag,
        "item-tag": _ctx.itemTag
    }, _ctx.$attrs, {
        onResize: $options.onScrollerResize,
        onVisible: $options.onScrollerVisible
    }), {
        default: withCtx(function (_a) {
            var itemWithSize = _a.item, index = _a.index, active = _a.active;
            return [
                renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({
                    item: itemWithSize.item,
                    index: index,
                    active: active,
                    itemWithSize: itemWithSize
                })))
            ];
        }),
        before: withCtx(function () { return [
            renderSlot(_ctx.$slots, "before")
        ]; }),
        after: withCtx(function () { return [
            renderSlot(_ctx.$slots, "after")
        ]; }),
        empty: withCtx(function () { return [
            renderSlot(_ctx.$slots, "empty")
        ]; }),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["items", "min-item-size", "direction", "list-tag", "item-tag", "onResize", "onVisible"]));
}
script$1.render = render;
script$1.__file = "src/components/DynamicScroller.vue";
var script = {
    name: 'DynamicScrollerItem',
    inject: [
        'vscrollData',
        'vscrollParent',
        'vscrollResizeObserver',
    ],
    props: {
        // eslint-disable-next-line vue/require-prop-types
        item: {
            required: true,
        },
        watchData: {
            type: Boolean,
            default: false,
        },
        /**
         * Indicates if the view is actively used to display an item.
         */
        active: {
            type: Boolean,
            required: true,
        },
        index: {
            type: Number,
            default: undefined,
        },
        sizeDependencies: {
            type: [Array, Object],
            default: null,
        },
        emitResize: {
            type: Boolean,
            default: false,
        },
        tag: {
            type: String,
            default: 'div',
        },
    },
    emits: [
        'resize',
    ],
    computed: {
        id: function () {
            if (this.vscrollData.simpleArray)
                return this.index;
            // eslint-disable-next-line no-prototype-builtins
            if (this.vscrollData.keyField in this.item)
                return this.item[this.vscrollData.keyField];
            throw new Error("keyField '".concat(this.vscrollData.keyField, "' not found in your item. You should set a valid keyField prop on your Scroller"));
        },
        size: function () {
            return this.vscrollData.sizes[this.id] || 0;
        },
        finalActive: function () {
            return this.active && this.vscrollData.active;
        },
    },
    watch: {
        watchData: 'updateWatchData',
        id: function (value, oldValue) {
            this.$el.$_vs_id = this.id;
            if (!this.size) {
                this.onDataUpdate();
            }
            if (this.$_sizeObserved) {
                // In case the old item had the same size, it won't trigger the ResizeObserver
                // since we are reusing the same DOM node
                var oldSize = this.vscrollData.sizes[oldValue];
                var size = this.vscrollData.sizes[value];
                if (oldSize != null && oldSize !== size) {
                    this.applySize(oldSize);
                }
            }
        },
        finalActive: function (value) {
            if (!this.size) {
                if (value) {
                    if (!this.vscrollParent.$_undefinedMap[this.id]) {
                        this.vscrollParent.$_undefinedSizes++;
                        this.vscrollParent.$_undefinedMap[this.id] = true;
                    }
                }
                else {
                    if (this.vscrollParent.$_undefinedMap[this.id]) {
                        this.vscrollParent.$_undefinedSizes--;
                        this.vscrollParent.$_undefinedMap[this.id] = false;
                    }
                }
            }
            if (this.vscrollResizeObserver) {
                if (value) {
                    this.observeSize();
                }
                else {
                    this.unobserveSize();
                }
            }
            else if (value && this.$_pendingVScrollUpdate === this.id) {
                this.updateSize();
            }
        },
    },
    created: function () {
        var _this_1 = this;
        if (this.$isServer)
            return;
        this.$_forceNextVScrollUpdate = null;
        this.updateWatchData();
        if (!this.vscrollResizeObserver) {
            var _loop_1 = function (k) {
                this_1.$watch(function () { return _this_1.sizeDependencies[k]; }, this_1.onDataUpdate);
            };
            var this_1 = this;
            for (var k in this.sizeDependencies) {
                _loop_1(k);
            }
            this.vscrollParent.$_events.on('vscroll:update', this.onVscrollUpdate);
        }
    },
    mounted: function () {
        if (this.finalActive) {
            this.updateSize();
            this.observeSize();
        }
    },
    beforeUnmount: function () {
        this.vscrollParent.$_events.off('vscroll:update', this.onVscrollUpdate);
        this.unobserveSize();
    },
    methods: {
        updateSize: function () {
            if (this.finalActive) {
                if (this.$_pendingSizeUpdate !== this.id) {
                    this.$_pendingSizeUpdate = this.id;
                    this.$_forceNextVScrollUpdate = null;
                    this.$_pendingVScrollUpdate = null;
                    this.computeSize(this.id);
                }
            }
            else {
                this.$_forceNextVScrollUpdate = this.id;
            }
        },
        updateWatchData: function () {
            var _this_1 = this;
            if (this.watchData && !this.vscrollResizeObserver) {
                this.$_watchData = this.$watch('item', function () {
                    _this_1.onDataUpdate();
                }, {
                    deep: true,
                });
            }
            else if (this.$_watchData) {
                this.$_watchData();
                this.$_watchData = null;
            }
        },
        onVscrollUpdate: function (_a) {
            var force = _a.force;
            // If not active, sechedule a size update when it becomes active
            if (!this.finalActive && force) {
                this.$_pendingVScrollUpdate = this.id;
            }
            if (this.$_forceNextVScrollUpdate === this.id || force || !this.size) {
                this.updateSize();
            }
        },
        onDataUpdate: function () {
            this.updateSize();
        },
        computeSize: function (id) {
            var _this_1 = this;
            this.$nextTick(function () {
                if (_this_1.id === id) {
                    var width = _this_1.$el.offsetWidth;
                    var height = _this_1.$el.offsetHeight;
                    _this_1.applyWidthHeight(width, height);
                }
                _this_1.$_pendingSizeUpdate = null;
            });
        },
        applyWidthHeight: function (width, height) {
            var size = ~~(this.vscrollParent.direction === 'vertical' ? height : width);
            if (size && this.size !== size) {
                this.applySize(size);
            }
        },
        applySize: function (size) {
            if (this.vscrollParent.$_undefinedMap[this.id]) {
                this.vscrollParent.$_undefinedSizes--;
                this.vscrollParent.$_undefinedMap[this.id] = undefined;
            }
            this.vscrollData.sizes[this.id] = size;
            if (this.emitResize)
                this.$emit('resize', this.id);
        },
        observeSize: function () {
            if (!this.vscrollResizeObserver)
                return;
            if (this.$_sizeObserved)
                return;
            this.vscrollResizeObserver.observe(this.$el);
            this.$el.$_vs_id = this.id;
            this.$el.$_vs_onResize = this.onResize;
            this.$_sizeObserved = true;
        },
        unobserveSize: function () {
            if (!this.vscrollResizeObserver)
                return;
            if (!this.$_sizeObserved)
                return;
            this.vscrollResizeObserver.unobserve(this.$el);
            this.$el.$_vs_onResize = undefined;
            this.$_sizeObserved = false;
        },
        onResize: function (id, width, height) {
            if (this.id === id) {
                this.applyWidthHeight(width, height);
            }
        },
    },
    render: function () {
        return h(this.tag, this.$slots.default());
    },
};
script.__file = "src/components/DynamicScrollerItem.vue";
function IdState() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$idProp = _ref.idProp, idProp = _ref$idProp === void 0 ? function (vm) {
        return vm.item.id;
    } : _ref$idProp;
    var store = reactive({});
    // @vue/component
    return {
        data: function data() {
            return {
                idState: null
            };
        },
        created: function created() {
            var _this = this;
            this.$_id = null;
            if (typeof idProp === 'function') {
                this.$_getId = function () {
                    return idProp.call(_this, _this);
                };
            }
            else {
                this.$_getId = function () {
                    return _this[idProp];
                };
            }
            this.$watch(this.$_getId, {
                handler: function handler(value) {
                    var _this2 = this;
                    this.$nextTick(function () {
                        _this2.$_id = value;
                    });
                },
                immediate: true
            });
            this.$_updateIdState();
        },
        beforeUpdate: function beforeUpdate() {
            this.$_updateIdState();
        },
        methods: {
            /**
             * Initialize an idState
             * @param {number|string} id Unique id for the data
             */ $_idStateInit: function $_idStateInit(id) {
                var factory = this.$options.idState;
                if (typeof factory === 'function') {
                    var data = factory.call(this, this);
                    store[id] = data;
                    this.$_id = id;
                    return data;
                }
                else {
                    throw new Error('[mixin IdState] Missing `idState` function on component definition.');
                }
            },
            /**
             * Ensure idState is created and up-to-date
             */ $_updateIdState: function $_updateIdState() {
                var id = this.$_getId();
                if (id == null) {
                    console.warn("No id found for IdState with idProp: '".concat(idProp, "'."));
                }
                if (id !== this.$_id) {
                    if (!store[id]) {
                        this.$_idStateInit(id);
                    }
                    this.idState = store[id];
                }
            }
        }
    };
}
function registerComponents(app, prefix) {
    app.component("".concat(prefix, "recycle-scroller"), script$2);
    app.component("".concat(prefix, "RecycleScroller"), script$2);
    app.component("".concat(prefix, "dynamic-scroller"), script$1);
    app.component("".concat(prefix, "DynamicScroller"), script$1);
    app.component("".concat(prefix, "dynamic-scroller-item"), script);
    app.component("".concat(prefix, "DynamicScrollerItem"), script);
}
var plugin = {
    // eslint-disable-next-line no-undef
    version: "2.0.0-beta.8",
    install: function install(app, options) {
        var finalOptions = Object.assign({}, {
            installComponents: true,
            componentsPrefix: ''
        }, options);
        for (var key in finalOptions) {
            if (typeof finalOptions[key] !== 'undefined') {
                config[key] = finalOptions[key];
            }
        }
        if (finalOptions.installComponents) {
            registerComponents(app, finalOptions.componentsPrefix);
        }
    }
};
export { script$1 as DynamicScroller, script as DynamicScrollerItem, IdState, script$2 as RecycleScroller, plugin as default };
//# sourceMappingURL=vue-virtual-scroller.esm.js.map
